/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Crosspostingstatusposted2Inputs */

const en_crosspostingstatusposted2 = /** @type {(inputs: Crosspostingstatusposted2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posted`)
};

const de_crosspostingstatusposted2 = /** @type {(inputs: Crosspostingstatusposted2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veröffentlicht`)
};

/**
* | output |
* | --- |
* | "Posted" |
*
* @param {Crosspostingstatusposted2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const crosspostingstatusposted2 = /** @type {((inputs?: Crosspostingstatusposted2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Crosspostingstatusposted2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_crosspostingstatusposted2(inputs)
	return de_crosspostingstatusposted2(inputs)
});
export { crosspostingstatusposted2 as "crosspostingStatusPosted" }